// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/partner_register/common/v1/registration.proto

/* oxlint-disable */

/** Registration completion status */
export const ApiRegistrationStatus = {
  /** REGISTRATION_STATUS_UNSPECIFIED - Unspecified registration status */
  REGISTRATION_STATUS_UNSPECIFIED: "REGISTRATION_STATUS_UNSPECIFIED",
  /**
   * Registration is pending
   */
  pending: "pending",
  /**
   * Registration is completed
   */
  completed: "completed",
  /**
   * Contract signing is pending
   */
  contract_sign_pending: "contract_sign_pending",
  /**
   * Contract signing has validation errors
   */
  contract_sign_validation_error: "contract_sign_validation_error",
} as const;

export type ApiRegistrationStatus = typeof ApiRegistrationStatus[keyof typeof ApiRegistrationStatus];

export namespace ApiRegistrationStatus {
  export type REGISTRATION_STATUS_UNSPECIFIED = typeof ApiRegistrationStatus.REGISTRATION_STATUS_UNSPECIFIED;
  export type pending = typeof ApiRegistrationStatus.pending;
  export type completed = typeof ApiRegistrationStatus.completed;
  export type contract_sign_pending = typeof ApiRegistrationStatus.contract_sign_pending;
  export type contract_sign_validation_error = typeof ApiRegistrationStatus.contract_sign_validation_error;
}

export function apiRegistrationStatusFromJSON(object: any): ApiRegistrationStatus {
  switch (object) {
    case 0:
    case "REGISTRATION_STATUS_UNSPECIFIED":
      return ApiRegistrationStatus.REGISTRATION_STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiRegistrationStatus.pending;
    case 2:
    case "completed":
      return ApiRegistrationStatus.completed;
    case 3:
    case "contract_sign_pending":
      return ApiRegistrationStatus.contract_sign_pending;
    case 4:
    case "contract_sign_validation_error":
      return ApiRegistrationStatus.contract_sign_validation_error;
    default:
      return ApiRegistrationStatus.REGISTRATION_STATUS_UNSPECIFIED;
  }
}

export function apiRegistrationStatusToJSON(object: ApiRegistrationStatus): string {
  switch (object) {
    case ApiRegistrationStatus.REGISTRATION_STATUS_UNSPECIFIED:
      return "REGISTRATION_STATUS_UNSPECIFIED";
    case ApiRegistrationStatus.pending:
      return "pending";
    case ApiRegistrationStatus.completed:
      return "completed";
    case ApiRegistrationStatus.contract_sign_pending:
      return "contract_sign_pending";
    case ApiRegistrationStatus.contract_sign_validation_error:
      return "contract_sign_validation_error";
    default:
      return "REGISTRATION_STATUS_UNSPECIFIED";
  }
}

/** Type of partner */
export const ApiPartnerType = {
  /** PARTNER_TYPE_UNSPECIFIED - Unspecified partner type */
  PARTNER_TYPE_UNSPECIFIED: "PARTNER_TYPE_UNSPECIFIED",
  /**
   * Legal tech partner
   */
  legal_tech: "legal_tech",
  /**
   * Accountant partner
   */
  accountant: "accountant",
  /**
   * Embed partner
   */
  embed: "embed",
} as const;

export type ApiPartnerType = typeof ApiPartnerType[keyof typeof ApiPartnerType];

export namespace ApiPartnerType {
  export type PARTNER_TYPE_UNSPECIFIED = typeof ApiPartnerType.PARTNER_TYPE_UNSPECIFIED;
  export type legal_tech = typeof ApiPartnerType.legal_tech;
  export type accountant = typeof ApiPartnerType.accountant;
  export type embed = typeof ApiPartnerType.embed;
}

export function apiPartnerTypeFromJSON(object: any): ApiPartnerType {
  switch (object) {
    case 0:
    case "PARTNER_TYPE_UNSPECIFIED":
      return ApiPartnerType.PARTNER_TYPE_UNSPECIFIED;
    case 1:
    case "legal_tech":
      return ApiPartnerType.legal_tech;
    case 2:
    case "accountant":
      return ApiPartnerType.accountant;
    case 3:
    case "embed":
      return ApiPartnerType.embed;
    default:
      return ApiPartnerType.PARTNER_TYPE_UNSPECIFIED;
  }
}

export function apiPartnerTypeToJSON(object: ApiPartnerType): string {
  switch (object) {
    case ApiPartnerType.PARTNER_TYPE_UNSPECIFIED:
      return "PARTNER_TYPE_UNSPECIFIED";
    case ApiPartnerType.legal_tech:
      return "legal_tech";
    case ApiPartnerType.accountant:
      return "accountant";
    case ApiPartnerType.embed:
      return "embed";
    default:
      return "PARTNER_TYPE_UNSPECIFIED";
  }
}

/** Flow type for registration eligibility */
export const ApiFlowType = {
  /** FLOW_TYPE_UNSPECIFIED - Unspecified flow type */
  FLOW_TYPE_UNSPECIFIED: "FLOW_TYPE_UNSPECIFIED",
  /**
   * User signs up through qonto.com
   */
  manual: "manual",
  /**
   * User signs up through partner-register.qonto.com
   */
  seamless: "seamless",
} as const;

export type ApiFlowType = typeof ApiFlowType[keyof typeof ApiFlowType];

export namespace ApiFlowType {
  export type FLOW_TYPE_UNSPECIFIED = typeof ApiFlowType.FLOW_TYPE_UNSPECIFIED;
  export type manual = typeof ApiFlowType.manual;
  export type seamless = typeof ApiFlowType.seamless;
}

export function apiFlowTypeFromJSON(object: any): ApiFlowType {
  switch (object) {
    case 0:
    case "FLOW_TYPE_UNSPECIFIED":
      return ApiFlowType.FLOW_TYPE_UNSPECIFIED;
    case 1:
    case "manual":
      return ApiFlowType.manual;
    case 2:
    case "seamless":
      return ApiFlowType.seamless;
    default:
      return ApiFlowType.FLOW_TYPE_UNSPECIFIED;
  }
}

export function apiFlowTypeToJSON(object: ApiFlowType): string {
  switch (object) {
    case ApiFlowType.FLOW_TYPE_UNSPECIFIED:
      return "FLOW_TYPE_UNSPECIFIED";
    case ApiFlowType.manual:
      return "manual";
    case ApiFlowType.seamless:
      return "seamless";
    default:
      return "FLOW_TYPE_UNSPECIFIED";
  }
}

/** Organization legal flow type */
export const ApiLegalFlow = {
  /** LEGAL_FLOW_UNSPECIFIED - Unspecified legal flow */
  LEGAL_FLOW_UNSPECIFIED: "LEGAL_FLOW_UNSPECIFIED",
  /**
   * New company creation
   */
  company_creation: "company_creation",
  /**
   * Existing company registration
   */
  existing_company: "existing_company",
  /**
   * Qonto invoicing flow
   */
  qonto_invoicing: "qonto_invoicing",
} as const;

export type ApiLegalFlow = typeof ApiLegalFlow[keyof typeof ApiLegalFlow];

export namespace ApiLegalFlow {
  export type LEGAL_FLOW_UNSPECIFIED = typeof ApiLegalFlow.LEGAL_FLOW_UNSPECIFIED;
  export type company_creation = typeof ApiLegalFlow.company_creation;
  export type existing_company = typeof ApiLegalFlow.existing_company;
  export type qonto_invoicing = typeof ApiLegalFlow.qonto_invoicing;
}

export function apiLegalFlowFromJSON(object: any): ApiLegalFlow {
  switch (object) {
    case 0:
    case "LEGAL_FLOW_UNSPECIFIED":
      return ApiLegalFlow.LEGAL_FLOW_UNSPECIFIED;
    case 1:
    case "company_creation":
      return ApiLegalFlow.company_creation;
    case 2:
    case "existing_company":
      return ApiLegalFlow.existing_company;
    case 3:
    case "qonto_invoicing":
      return ApiLegalFlow.qonto_invoicing;
    default:
      return ApiLegalFlow.LEGAL_FLOW_UNSPECIFIED;
  }
}

export function apiLegalFlowToJSON(object: ApiLegalFlow): string {
  switch (object) {
    case ApiLegalFlow.LEGAL_FLOW_UNSPECIFIED:
      return "LEGAL_FLOW_UNSPECIFIED";
    case ApiLegalFlow.company_creation:
      return "company_creation";
    case ApiLegalFlow.existing_company:
      return "existing_company";
    case ApiLegalFlow.qonto_invoicing:
      return "qonto_invoicing";
    default:
      return "LEGAL_FLOW_UNSPECIFIED";
  }
}

/** Billing recurrence */
export const ApiRecurrence = {
  /** RECURRENCE_UNSPECIFIED - Unspecified recurrence */
  RECURRENCE_UNSPECIFIED: "RECURRENCE_UNSPECIFIED",
  /**
   * Monthly billing
   */
  monthly: "monthly",
  /**
   * Annual billing
   */
  annual: "annual",
} as const;

export type ApiRecurrence = typeof ApiRecurrence[keyof typeof ApiRecurrence];

export namespace ApiRecurrence {
  export type RECURRENCE_UNSPECIFIED = typeof ApiRecurrence.RECURRENCE_UNSPECIFIED;
  export type monthly = typeof ApiRecurrence.monthly;
  export type annual = typeof ApiRecurrence.annual;
}

export function apiRecurrenceFromJSON(object: any): ApiRecurrence {
  switch (object) {
    case 0:
    case "RECURRENCE_UNSPECIFIED":
      return ApiRecurrence.RECURRENCE_UNSPECIFIED;
    case 1:
    case "monthly":
      return ApiRecurrence.monthly;
    case 2:
    case "annual":
      return ApiRecurrence.annual;
    default:
      return ApiRecurrence.RECURRENCE_UNSPECIFIED;
  }
}

export function apiRecurrenceToJSON(object: ApiRecurrence): string {
  switch (object) {
    case ApiRecurrence.RECURRENCE_UNSPECIFIED:
      return "RECURRENCE_UNSPECIFIED";
    case ApiRecurrence.monthly:
      return "monthly";
    case ApiRecurrence.annual:
      return "annual";
    default:
      return "RECURRENCE_UNSPECIFIED";
  }
}

/** Registration represents a partner registration linked to an organization */
export interface ApiRegistration {
  /** Unique identifier of the registration */
  readonly id: string;
  /** Whether the registration process is finished */
  readonly status: ApiRegistrationStatus;
  /** Name of the partner */
  readonly partnerName: string;
  /** Type of partner */
  readonly partnerType: ApiPartnerType;
  /** URL where the user will be redirected after registration completion (embed apps only) */
  readonly partnerRedirectUrl?:
    | string
    | null
    | undefined;
  /** Flow this registration is eligible for */
  readonly flowType: ApiFlowType;
  /** Organization legal flow type */
  readonly legalFlow: ApiLegalFlow;
  /** Code of the price plan selected by the user */
  readonly pricePlanCode?:
    | string
    | null
    | undefined;
  /** Recurrence selected by the user */
  readonly originalRecurrence: ApiRecurrence;
  /** Whether the registration has an associated successful payment */
  readonly isPaid: boolean;
  /** Whether the organization is created from the full company creation flow */
  readonly companyCreationFromScratch: boolean;
  /** ID of the organization linked to this registration */
  readonly organizationId: string;
  /** IDs of the stakeholders linked to this registration */
  readonly stakeholderIds: readonly string[];
  /** Source of prepayment for the registration */
  readonly prepaidSource?: string | null | undefined;
}

export const ApiRegistration: MessageFns<ApiRegistration> = {
  fromJSON(object: any): ApiRegistration {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      status: isSet(object.status)
        ? apiRegistrationStatusFromJSON(object.status)
        : ApiRegistrationStatus.REGISTRATION_STATUS_UNSPECIFIED,
      partnerName: isSet(object.partner_name) ? globalThis.String(object.partner_name) : "",
      partnerType: isSet(object.partner_type)
        ? apiPartnerTypeFromJSON(object.partner_type)
        : ApiPartnerType.PARTNER_TYPE_UNSPECIFIED,
      partnerRedirectUrl: isSet(object.partner_redirect_url) ? globalThis.String(object.partner_redirect_url) : null,
      flowType: isSet(object.flow_type) ? apiFlowTypeFromJSON(object.flow_type) : ApiFlowType.FLOW_TYPE_UNSPECIFIED,
      legalFlow: isSet(object.legal_flow)
        ? apiLegalFlowFromJSON(object.legal_flow)
        : ApiLegalFlow.LEGAL_FLOW_UNSPECIFIED,
      pricePlanCode: isSet(object.price_plan_code) ? globalThis.String(object.price_plan_code) : null,
      originalRecurrence: isSet(object.original_recurrence)
        ? apiRecurrenceFromJSON(object.original_recurrence)
        : ApiRecurrence.RECURRENCE_UNSPECIFIED,
      isPaid: isSet(object.is_paid) ? globalThis.Boolean(object.is_paid) : false,
      companyCreationFromScratch: isSet(object.company_creation_from_scratch)
        ? globalThis.Boolean(object.company_creation_from_scratch)
        : false,
      organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "",
      stakeholderIds: globalThis.Array.isArray(object?.stakeholder_ids)
        ? object.stakeholder_ids.map((e: any) => globalThis.String(e))
        : [],
      prepaidSource: isSet(object.prepaid_source) ? globalThis.String(object.prepaid_source) : null,
    };
  },

  toJSON(message: ApiRegistration): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiRegistrationStatusToJSON(message.status);
    }
    if (message.partnerName !== undefined && message.partnerName !== null) {
      obj.partner_name = message.partnerName;
    }
    if (message.partnerType !== undefined && message.partnerType !== null) {
      obj.partner_type = apiPartnerTypeToJSON(message.partnerType);
    }
    if (message.partnerRedirectUrl !== undefined && message.partnerRedirectUrl !== null) {
      obj.partner_redirect_url = message.partnerRedirectUrl;
    }
    if (message.flowType !== undefined && message.flowType !== null) {
      obj.flow_type = apiFlowTypeToJSON(message.flowType);
    }
    if (message.legalFlow !== undefined && message.legalFlow !== null) {
      obj.legal_flow = apiLegalFlowToJSON(message.legalFlow);
    }
    if (message.pricePlanCode !== undefined && message.pricePlanCode !== null) {
      obj.price_plan_code = message.pricePlanCode;
    }
    if (message.originalRecurrence !== undefined && message.originalRecurrence !== null) {
      obj.original_recurrence = apiRecurrenceToJSON(message.originalRecurrence);
    }
    if (message.isPaid !== undefined && message.isPaid !== null) {
      obj.is_paid = message.isPaid;
    }
    if (message.companyCreationFromScratch !== undefined && message.companyCreationFromScratch !== null) {
      obj.company_creation_from_scratch = message.companyCreationFromScratch;
    }
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    if (message.stakeholderIds?.length) {
      obj.stakeholder_ids = message.stakeholderIds;
    }
    if (message.prepaidSource !== undefined && message.prepaidSource !== null) {
      obj.prepaid_source = message.prepaidSource;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
